import { render, staticRenderFns } from "./VrstaSuorganizatoraBase.vue?vue&type=template&id=0e078c7b&scoped=true&"
import script from "./VrstaSuorganizatoraBase.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e078c7b",
  null
  
)

export default component.exports